import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type IdMapping = Record<string, { id: string; page: number }[]>;

type ConditionalLogicStoreReducer = {
  sourceToTarget: IdMapping;
  targetToSource: IdMapping;
  sourceBlockFieldMapping: IdMapping;
};

const initialState: ConditionalLogicStoreReducer = {
  sourceToTarget: {},
  targetToSource: {},
  sourceBlockFieldMapping: {},
};

export const conditionalLogicSlice = createSlice({
  name: 'conditionalLogicSlice',
  initialState,
  reducers: {
    setConditionalLogicStore: (
      state,
      action: PayloadAction<Partial<ConditionalLogicStoreReducer>>,
    ) => {
      return { ...state, ...action.payload };
    },
    updateBidirectionalMapping: (
      state,
      action: PayloadAction<{
        sourceToTarget: IdMapping;
        targetToSource: IdMapping;
        sourceBlockFieldMapping: IdMapping;
      }>,
    ) => {
      const { sourceToTarget, targetToSource, sourceBlockFieldMapping } = action.payload;
      return {
        ...state,
        sourceToTarget,
        targetToSource,
        sourceBlockFieldMapping,
      };
    },
  },
});

export const { setConditionalLogicStore, updateBidirectionalMapping } =
  conditionalLogicSlice.actions;

export default conditionalLogicSlice.reducer;
